/**
 * Location Service
 * Handles all location-related API calls (cities and districts)
 * Cities and districts are managed by admin and available to everyone
 */
const locationService = {
    /**
     * Get all cities with districts (for all dropdowns)
     * @param {string} lang - Language (ar/en)
     * @returns {Promise<Object>}
     */
    getAllCities: async (lang = 'ar') => {
        const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://back.miskest.com/api/v1';
        const response = await fetch(`${API_BASE_URL}/public/locations/all?lang=${lang}`);
        return response.json();
    }
};

export default locationService;
